export default [
  {
    path: "/login",
    name: "auth.login",
    component: () => import(/* webpackChunkName: "auth" */ "./login"),
    meta: {
      auth: "guest",
    },
  },
];
